export enum CalibrationStatus {
    OnayBekliyor = 1,
    Tamamlandı = 2,
    İptalEdildi = 3
}